import { render, staticRenderFns } from "./sintesis.vue?vue&type=template&id=ecf3eeaa&lang=pug&"
import script from "./sintesis.vue?vue&type=script&lang=js&"
export * from "./sintesis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports